import Image from "../../assets/logo.png"
import { Trans, useTranslation } from 'react-i18next';
import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { AutoComplete, Input, Modal, Spin } from 'antd';
import { DownOutlined, SearchOutlined } from '@ant-design/icons';
import api from '../api';
import QuestionItem from '../Quiz/Fragments/QuestionItem';

const AppHeader = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();
    
    // Search states
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedQuestion, setSelectedQuestion] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);

    const { t, i18n } = useTranslation();

    useEffect(() => {
        setMenuOpen(false);
    }, [location]);

    const handleSearch = (value) => {
        if (!value || value.length < 3) {
            setOptions([]);
            return;
        }
        setLoading(true);
        api.API.get(`api/questions?q=${value}`).then(res => {
            const data = res.data || res;
            const results = Array.isArray(data) ? data : (res.data || []);
            setOptions(
                results.map(item => ({
                    value: item.question,
                    label: (
                        <div style={{ display: 'flex', alignItems: 'center', padding: '5px 0' }}>
                            {item.image && (
                                <img 
                                    src={process.env.REACT_APP_API_ENDPOINT + item.image} 
                                    alt="" 
                                    style={{ width: '40px', height: '30px', objectFit: 'cover', borderRadius: '4px', marginRight: '10px' }}
                                />
                            )}
                            <div style={{ whiteSpace: 'normal', flex: 1 }}>
                                {item.question.length > 80 ? item.question.substring(0, 80) + '...' : item.question}
                            </div>
                        </div>
                    ),
                    question: item
                }))
            );
            setLoading(false);
        }).catch(() => setLoading(false));
    };

    const onSelect = (value, option) => {
        setSelectedQuestion(option.question);
        setIsModalVisible(true);
    };

    return (
        <header className="header">
            <Link to="/" className="logo" style={{ background: "url('" + Image + "')" }}></Link>

            <div className={`menu-toggle ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(!menuOpen)}>
                <span className="navicon"></span>
            </div>

            <ul className={`menu ${menuOpen ? 'menu-open' : ''}`}>
                <li className="header-search-container" style={{ padding: '10px 20px', minWidth: '250px' }}>
                    <AutoComplete
                        dropdownMatchSelectWidth={300}
                        style={{ width: '100%' }}
                        options={options}
                        onSelect={onSelect}
                        onSearch={handleSearch}
                    >
                        <Input 
                            placeholder={t('header.search_placeholder')} 
                            prefix={loading ? <Spin size="small" /> : <SearchOutlined />} 
                        />
                    </AutoComplete>
                </li>

                <li>
                    <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
                        {t('header.home')}
                    </Link>
                </li>
                
                <li className="has-submenu">
                    <span className="submenu-title">
                        {t('header.tests')} <DownOutlined style={{ fontSize: '10px' }} />
                    </span>
                    <ul className="submenu">
                        <li><Link to="/quizes">{t('header.exam_tests')}</Link></li>
                        <li><Link to="/battle">{t('battle.mode_title')}</Link></li>
                        <li><Link to="/psycho">{t('header.psycho')}</Link></li>
                    </ul>
                </li>

                <li className="has-submenu">
                    <span className="submenu-title">
                        {t('header.educational')} <DownOutlined style={{ fontSize: '10px' }} />
                    </span>
                    <ul className="submenu">
                        <li><Link to="/categories">{t('header.grouped_questions')}</Link></li>
                        <li><Link to="/learn">{t('header.learn_rules')}</Link></li>
                        <li><Link to="/traffic-signs">{t('header.traffic_signs')}</Link></li>
                    </ul>
                </li>

                <li className="has-submenu">
                    <span className="submenu-title">
                        {t('header.my_results')} <DownOutlined style={{ fontSize: '10px' }} />
                    </span>
                    <ul className="submenu">
                        <li><Link to="/wrongs">{t('header.wrongs')}</Link></li>
                        <li><Link to="/favorites">{t('header.favorites')}</Link></li>
                    </ul>
                </li>
            </ul>

            <Modal
                title={t('header.answer_title')}
                visible={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
                width={800}
                destroyOnClose
            >
                {selectedQuestion && (
                    <QuestionItem 
                        currentQuestion={selectedQuestion} 
                        noSubmit={false}
                        handleNext={() => setIsModalVisible(false)} // Close on answer
                    />
                )}
            </Modal>
        </header>
    );
};

export default AppHeader;